export default {
  getUsername: state => state.username,
  getTelegramId: state => state.telegramId,
  getTelegramParams: state => state.telegramParams,
  getVtMarketsBot: state => state.vtMarketsBot,
  getTelegramToRouterPath: state => state.telegramToRouterPath,
  getTgBtn: state => state.tgBtn,
  getTelegramCampaignCode: state => state.telegramCampaignCode,
  getTgLinks: state => state.tgLinks,
  getTgOriPath: state => state.tgOriPath,
  getSkipResetTgLink: state => state.skipResetTgLink,
  getSidebarMenu: state => state.sidebarMenu,
  getSidebarMenuActive: state => state.sidebarMenuActive,
  getDisplayTelegram: () => ['myaccount.vtmarkets.com'].includes(window.location.hostname),
}
